
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/internship",
      function () {
        return require("private-next-pages/internship/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/internship"])
      });
    }
  